/**
 * Degradado bajo el header fijo: oculta el contenido (imágenes, etc.) que
 * asoma detrás del menú. Color base = mismo fondo que body (#0a090c).
 */
export default function TopNavScrim() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-x-0 top-0 z-40 h-36 sm:h-40 md:h-44"
      style={{
        background:
          'linear-gradient(180deg, #0a090c 0%, #0a090c 8%, rgba(10,9,12,0.94) 32%, rgba(10,9,12,0.55) 65%, rgba(10,9,12,0) 100%)',
      }}
    />
  );
}
